export default "__VITE_ASSET__DYNdNoX3__"